import React from 'react'
import styled from '@emotion/styled'

const FlexBox = styled.div`
  background-color: ${({ blueBg }) => (blueBg ? '#f6f9fc' : 'transparent')};
  padding-top: 5rem;
  padding-bottom: 5rem;

      @media (max-width: 640px) {
      flex-direction: column-reverse;
      align-items: center;
      padding-top: 3rem;
      padding-bottom: 0rem;
    }

  .wrapper {
    max-width: 1240px;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    column-gap: 2%;

    @media (max-width: 640px) {
      flex-direction: column-reverse;
      align-items: flex-start;
      row-gap: 4rem;
      align-items: center;
      margin-bottom: 5rem;
      margin-top: 0;
    }
  }

  .content {
    width: 49%;
    max-width: 100%;

        @media (max-width: 640px) {
            width: 100%;
            padding-left: 1.25rem;
            padding-right: 1.25rem;
        }
    }

    h2 {
      font-family: 'Montserrat', 'DejaVu Sans', 'Verdana', 'sans-serif';
      font-weight: 300;
      font-size: 2.25rem;
      margin: 0;
      margin-bottom: 0px;
      margin-bottom: 1.5rem;
      word-wrap: break-word;
    }

    div {
      p {
        font-family: 'Raleway', 'Lucida Grande', 'Tahoma', 'sans-serif';
        font-size: 1.125rem;
        color: #4f5354;
        line-height: 2;
      }
    }
  }

  .image {
    width: 49%;
    text-align: center;
            @media (max-width: 640px) {
            width: 100%;
            padding-left: 1.25rem;
            padding-right: 1.25rem;
        }

    img {
      width: 100%;
      height: auto;
    }
  }
`

const ImageAndText = ({ reverse, blueBg, img, content }) => {
  return (
    <FlexBox reverse={reverse} blueBg={blueBg}>
      <div className="wrapper">
        <div className="content">
          {content.map(block => {
            if (block.__typename === 'HeaderBlock') {
              return (
                <h2
                  key={block.guid}
                  dangerouslySetInnerHTML={{ __html: block.title }}
                />
              )
            }
            if (block.__typename === 'TextBlock') {
              return (
                <div
                  key={block.guid}
                  dangerouslySetInnerHTML={{ __html: block.text }}
                />
              )
            }
            return null
          })}
        </div>
        <div className="image">
          <img src={img} alt="" />
        </div>
      </div>
    </FlexBox>
  )
}

export default ImageAndText
